


import {catchError} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FgiBackEndService } from '../fgi-back-end.service';
import { LimiteAportado } from 'src/app/model/limite-aportado.model';
import { BnFileUploaderComponent, FileUploaderArquivo } from "@bndes/bndes-ux4/bn-file-uploader";

@Injectable({
  providedIn: 'root'
})
export class LimiteAporteService extends FgiBackEndService<LimiteAportado>{
  // @Override
  getNewEntity() {
    return new LimiteAportado();
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/limiteAporte';
  }

  public getLimites(ideAgente: number): Observable<LimiteAportado[]> {
    const params: any = {}
    if (ideAgente) {
      params.idAgente = ideAgente;
    }
    return this.http.get(`rest/front/limiteAporte/limites`, { params: params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<LimiteAportado[]>;
  }

  public getLimiteGlobal(): Observable<LimiteAportado> {
    return this.http.get(`rest/front/limiteAporte/limite-global`).pipe(
      catchError((e) => this.handleError(e))) as Observable<LimiteAportado>;
  }

  enviarArquivo(url: string, file: FileUploaderArquivo): Observable<any> {
    const formData = new FormData();
    formData.append('file', file.arquivo);
    return this.http.post(url, formData).pipe
       (catchError((e) => this.handleError(e))) as Observable<any>;
}
    
 async importarArquivoLegadoAporte( uploader: BnFileUploaderComponent): Promise<any> {
    const url = `${this.BASE_URL}/importar-legado-aporte`;
    const listaPendente = [...uploader.listaPendente];
    for (const file of listaPendente) {
      await this.enviarArquivo(url, file).toPromise();
    }
  }  
    
}
